import React from 'react';

interface KpiCardProps {
  label: string;
  value: string | number;
  color: string;
}

const KpiCard: React.FC<KpiCardProps> = ({ label, value, color }) => (
  <div style={{ ...styles.kpiCardStyle, borderColor: color }}>
    <div style={styles.kpiLabelStyle}>{label}</div>
    <div style={{ ...styles.kpiValueStyle, color }}>{value}</div>
  </div>
);

const styles: Record<string, React.CSSProperties> = {
  kpiCardStyle: {
    backgroundColor: '#ffffff', // bg-white
    borderRadius: '16px', // rounded-2xl
    boxShadow:
      '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)', // shadow
    borderTopWidth: '4px',
    padding: '24px', // p-6
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    height: '100%',
    minWidth: '220px',
    width: '100%',
    maxWidth: '280px',
    transition: 'transform 200ms',
  } as React.CSSProperties,
  kpiLabelStyle: {
    fontSize: '16px', // text-base
    fontWeight: '600', // font-semibold
    color: '#4A4A4A',
  },
  kpiValueStyle: {
    fontSize: '30px', // text-3xl
    fontWeight: 'bold',
  },
};

export default KpiCard;
